import { Injectable, ɵConsole } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  //Not needed
  // registerUser(userData): Observable<any> {
  //
  //   console.log(userData)
  //   const httpOptions = {
  //     headers: new HttpHeaders({ 'Content-Type': 'application/json'})
  //   };
  //   //return this.httpClient.post('http://127.0.0.1:8000/new_user',userData);
  //   return this.httpClient.post('http://127.0.0.1:8000/new_user/create',(userData), httpOptions);
  // }

  login(email: string, password: string): Observable<any> {

    return this.httpClient.post(environment.apiUrl+'/auth/login/',{ email, password });
  }

  getInfo(): Observable<any> {
    return this.httpClient.get(environment.apiUrl+'/user/');
  }



}
